export default "__VITE_ASSET__elQIjZJ2__"